import React from 'react';
import { useTranslation } from 'react-i18next';

type ContentErrorStateProps = {
  onRetry: () => void;
};

/**
 * Error state component displayed when content fetching fails.
 * Shows a simple error message with a retry button.
 */
export const ContentErrorState: React.FC<ContentErrorStateProps> = ({
  onRetry,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center gap-2 py-6">
      <p className="text-sm text-spring-neutral-b3">
        {t('content-recording.content-composer.generated-content.load-failed')}
      </p>
      <button
        type="button"
        onClick={onRetry}
        className="px-3 py-1.5 text-sm font-medium text-spring-blue-2 hover:text-spring-blue-1 transition-colors rounded-md hover:bg-spring-neutral-b5/10"
      >
        {t('content-recording.content-composer.generated-content.retry')}
      </button>
    </div>
  );
};
